import { Controller } from 'react-hook-form';
import { Button, DragAndDrop } from '@/components/common';
import { DocumentType } from '@/api/common.types';
import { useSubmitVerificationDocument } from '@/hooks';
import styles from './Steps.module.css';

interface CompanyExtractProps {
  setStep: (step: number) => void;
}

export const CompanyExtract = ({ setStep }: CompanyExtractProps) => {
  const { control, handleSubmit, isDirty, isValid, isSubmitting, onSubmit, reset } = useSubmitVerificationDocument(
    DocumentType.COMPANY_EXTRACT,
    () => setStep(2),
  );

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <h3 className={styles.title}>Please provide a company extract. * </h3>
      <Controller
        name="document"
        control={control}
        render={({ field: { ref, ...rest } }) => <DragAndDrop {...rest} className={styles.input} />}
      />

      <Button fluid variants="secondaryGray" className={styles.clearFilesBtn} onPress={() => reset()}>
        Clear files
      </Button>
      <Button
        fluid
        icon="chevronRight"
        iconPosition="right"
        type="submit"
        // className={styles.button}
        loading={isSubmitting}
        isDisabled={!isDirty || !isValid}
      >
        Next Step
      </Button>
    </form>
  );
};
